import { Container, Flex, Text } from "@radix-ui/themes"
import React from "react"
import {PinBottomIcon} from '@radix-ui/react-icons'
import { gen_uniq_number } from "../../../utils"
import { FileArray } from "../../../pages/admin/create-post"
export interface FileInputProps extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  classNameContainer?: string,
  classNamelabel?: string,
  contentLabel?: React.JSX.Element,
  handleDrop?: (e: React.DragEvent<HTMLLabelElement>) => any
  setFileInStore?: React.Dispatch<React.SetStateAction<FileArray[]>>
}


export default function FileInput(props: FileInputProps) {
    const {id, type, multiple, className, classNameContainer, contentLabel, classNamelabel, handleDrop, onChange, setFileInStore, ...other} = props
    const handleAppDrop = (event: React.DragEvent<HTMLLabelElement>) => {
                  if(setFileInStore) {
                  event.preventDefault()
                  const files = event.dataTransfer.files
                  if(files && multiple) {
                  const newFiles = Array.from(files).map((file) => ({
                    id: gen_uniq_number(1000000, 9999999), 
                    name: file.name,
                    url: URL.createObjectURL(file),
                    file
                  }));
                  console.log(newFiles)
                  setFileInStore((prevFiles) => [...prevFiles, ...newFiles]);
              }
              if(files && !multiple) {
                setFileInStore([{
                    id: gen_uniq_number(1000000, 9999999), 
                    name: files[0].name,
                    url: URL.createObjectURL(files[0]),
                    file: files[0]
                  }])
              }
            }
    }

    const onChangeApp = (event: React.ChangeEvent<HTMLInputElement>) => {
         console.log(id)
                  if(setFileInStore) {
                   
                  const files = event.target.files
                  if(files) {
                  if(files.length && multiple) {
                    console.log('onchangeapp')
                  const newFiles = Array.from(files).map((file) => ({
                  id: gen_uniq_number(1000000, 999999), 
                    name: file.name,
                    url: URL.createObjectURL(file),
                    file
                  }));
                  setFileInStore((prevFiles) => [...prevFiles, ...newFiles]);
                }
                if(files.length && !multiple) {
                  console.log(files)
                  setFileInStore([{
                  id: gen_uniq_number(1000000, 999999), 
                    name: files[0].name,
                    url: URL.createObjectURL(files[0]),
                    file: files[0]
                  }])
                }
              }
              }
    }



    return (
      <Container className={`${classNameContainer}`}>
      <input 
      {...other} 
      type={"file"}
      id={id || "field__file-2"} 
      className={`invisible ${className}`} 
      draggable={'true'}
      onChange={onChange || setFileInStore && onChangeApp}
      multiple={multiple}
      />
      <label className={`field__file-wrapper border-4 border-dashed border-[#4287f5] p-5 cursor-pointer hover:shadow-lg hover:bg-blue-200 flex items-center justify-center transition-all duration-300 ${classNamelabel}`} htmlFor={id || "field__file-2"}
      draggable={'true'}
      onDragOver={e => e.preventDefault()}
      onDrop={handleDrop || setFileInStore && handleAppDrop}
      >
                {contentLabel ? contentLabel : 
                <Flex>
                <Text>Изображение</Text>
                <PinBottomIcon width={'30px'} height={'30px'} />
                </Flex>
}
      </label>
      </Container>
    )
}